import axios from 'axios'
// import Vuetify from 'vuetify'

/**
 * Per accedere globalmente a questo modulo usare rootState, rootGetters negli altri moduli
 * 
 * Esempio:
 * getters: {
 *  getRoute(state, getters, rootState) {
 *    return rootState.route;
 *   }
 * }
 */

export default {
	namespaced: true,
	
	state: {
		// global variables
		bando: null,
		
		impostazioni: {
			accountManagersIds: []
		}
	},

	getters: {
		bando (state) {
			return state.bando;
		},
		impostazioni(state) {
			return state.impostazioni;
		}
	},

	mutations: { // è il setter dello store, è sincrona, quindi meglio non usarla per fare chiamate api
		SET_BANDO (state, bando) {
			state.bando = bando
		},
		SET_IMPOSTAZIONI(state, impostazioni) {
			state.impostazioni = impostazioni;
		}
	},

	actions: { // sono asincrone, posso fare chiamate api e richiamare poi la mutation
		globalVariables ({ commit }) {
			return axios.get('/api/global-variables')
				.then(response => {
					commit('SET_BANDO', response.data.bando);
				})
		},
		unsetGlobalVariables ({ commit }) {
			commit('SET_BANDO', null);
		},
		salvaImpostazioniAm({ commit, getters, rootState }) {
			// si è scelto di salvare solo gli account managers selezionati
			commit('SET_IMPOSTAZIONI', {
				accountManagersIds: rootState.sharedFilters.accountManagersIds.value
			});
			
			axios.post('/api/account-managers/impostazioni', getters.impostazioni);
		},
		ottieniImpostazioniAm({ rootGetters, commit }) {
			return axios.get('/api/account-managers/impostazioni')
				.then(response => {
					if (typeof response.data === 'object') {
						commit('sharedFilters/SET_ACCOUNT_MANAGERS_IDS_APPLIED', response.data.accountManagersIds, { root: true });
						commit('sharedFilters/SET_ACCOUNT_MANAGERS_IDS_NOT_APPLIED', response.data.accountManagersIds, { root: true });
					}
				})
		},
	}
}